import { defineComponent } from 'vue';
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js';
ChartJS.register(Title, Tooltip, Legend, ArcElement);

export default defineComponent({
  name: 'PieChartComponent',
  components: { Doughnut },
  props: {
    chartData: {
      type: Object
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 300
    },
  },
  setup: () => {
    const chartOptions = {
      maintainAspectRatio: false,
    };

    return {
      chartOptions,
    };
  }
});
